'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Placeholder = styled__default.default.span `
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.designTokens.iconPlaceholderBorderRadius};
  background: ${({ theme }) => theme.designTokens.iconPlaceholderBackgroundColor};
`;

exports.Placeholder = Placeholder;
//# sourceMappingURL=Placeholder.js.map
